<div cdkDrag cdkDragRootElement=".modal-dialog" class="modal-outer-body d-flex flex-column justify-content-between">
    <div class="modal-header d-flex flex-row justify-content-between" cdkDragHandle>
      <div class="h4 p-2">Dialer Test Result</div>
      <button  type="button" class="close m-0 p-1" aria-label="Close" (click)="onCancel()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body" *ngIf="seqContext?.seq">
      <tabset>
        <tab heading="Handset Summary" [active]="!activeTab||activeTab=='summary'">
          <div class="tab-content-container" style="width: 100%">
            <div style="margin-bottom:18px;">
            <app-dialer-client-testseq [seqContext]="seqContext" (rootTest)="rootTestChanged($event)"> </app-dialer-client-testseq>
            </div>
          </div>
        </tab>
        <tab heading="Calls" [active]="activeTab=='calls'">
          <div class="tab-content-container">
            <fes-dialer-client-result-calls-table [callTests]="callTests"></fes-dialer-client-result-calls-table>
          </div>
        </tab>
        <tab heading="Config" [active]="activeTab=='config'">
          <div class="tab-content-container">
            <div class="d-flex flex-row justify-content-start">
              <div class="alert alert-warning" *ngIf="!testProfile">
                <i class="fa fa-exclamation-triangle mr-2"></i>
                <strong>Config could not be extracted from test results</strong>
              </div>
              <div>
              <table class="mb-0 table table-striped table-bordered table-sm" *ngIf="testProfile">
                <tbody>
                  <tr>
                    <th>Name</th>
                    <td>{{ testProfile.name }}</td>
                  </tr>
                  <tr>
                    <th>Target Call Count</th>
                    <td>{{ testProfile.callCount }}</td>
                  </tr>
                  <tr>
                    <th>Target Call Duration</th>
                    <td title="Seconds">{{ testProfile.callDurationSecs }}</td>
                  </tr>
                  <tr>
                    <th>Call Wait Interval</th>
                    <td title="Seconds">{{ testProfile.callWaitSecs }}</td>
                  </tr>
                  <tr>
                    <th>Call Setup Max Wait</th>
                    <td title="Seconds">{{ testProfile.callSetupTimeoutSecs }}</td>
                  </tr>
                  <tr>
                    <th>Group Wait Interval</th>
                    <td title="Seconds">{{ testProfile.groupWaitSecs }}</td>
                  </tr>
                  <ng-container *ngIf="testProfile.earlyDisconnectToleranceSecs">
                    <tr>
                      <th>Early Disconnect Tolerance</th>
                      <td title="Seconds">{{ testProfile.earlyDisconnectToleranceSecs }}</td>
                    </tr>
                    <tr>
                      <th>Early Disconnect Apply RegEx</th>
                      <td>{{ testProfile.earlyDisconnectCarrierRegex }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </tab>
        <tab heading="Environment" [active]="activeTab=='env'">
          <div class="tab-content-container">
          <div class="d-flex flex-row justify-content-start">
            <div>
              <div *ngIf="seqContext.seq?.data" class="card mr-2">
                <table class="mb-0 table table-striped table-bordered table-sm">
                  <tbody *ngLet="seqContext.seq.data as data">
                    <tr>
                      <th>Calls Placed (#)</th>
                      <td>{{ data.callsPlaced }}</td>
                    </tr>
                    <tr>
                      <th>Calls Completed (#)</th>
                      <td>{{ data.callsCompleted }}</td>
                    </tr>
                    <tr>
                      <th>HVAC</th>
                      <td>{{ data.hvac }}</td>
                    </tr>
                    <tr>
                      <th>Door open/shut count (#)</th>
                      <td>{{ data.doorOpenShutCount }}</td>
                    </tr>
                    <tr>
                      <th>Foot Traffic</th>
                      <td>{{ data.footTraffic }}</td>
                    </tr>
                    <tr *ngFor="let participant of pathTestService.participants">
                      <th>{{participant.title}} (dBm)</th>
                      <td>{{data[participant.name]}}</td>
                    </tr>
                    <tr>
                      <th>Issues with test location?</th>
                      <td>{{ data.string }}</td>
                    </tr>
                    <tr>
                      <th>Timestamp</th>
                      <td>{{ data.timestamp }}</td>
                    </tr>
                    <tr>
                      <th>Saved By</th>
                      <td>{{ dataUserName$ | async }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <div class="card">
                <table class="mb-0 table table-striped table-bordered table-sm">
                  <tbody>
                    <tr>
                      <th>Start Time</th>
                      <td>{{ seqContext.seq.startTime }}</td>
                    </tr>
                    <tr>
                      <th>Stop Time</th>
                      <td>{{ seqContext.seq.stopTime }}</td>
                    </tr>
                    <tr>
                      <th>Dialer Seq ID</th>
                      <td>{{ seqContext.seq.dialerSeqId }}</td>
                    </tr>
                    <tr>
                      <th>User</th>
                      <td>{{ seqUserName$ | async }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </div>
          </div>
        </tab>

        <tab heading="JSON" [active]="activeTab=='json'">
          <div class="tab-content-container">
            <pre><code>{{rootTest|json}}</code></pre>
          </div>
        </tab>
      </tabset>
      </div>

  <div class="mt-1 p-3 d-flex flex-row justify-content-between modal-footer">
    <div>
      <button *ngIf="rootTest?.seqId" class="btn btn-light" (click)="showDialerCallLog()">
        Dialer Call Logs
      </button>
      <button class="btn btn-light btn-sm ml-2 smaller" (click)="showDbgBtns=!showDbgBtns"
        title="{{showDbgBtns?'Hide':'Show'}} additional options">
        <i class="fa {{showDbgBtns?'fa-chevron-left':'fa-chevron-right'}} text-secondary"></i>
      </button>
      <ng-container *ngIf="showDbgBtns">
      <button *ngIf="rootTest" class="btn btn-light ml-2"
        title="Export Bluetooth call data"
        [disabled]='bExportingCalls' (click)="exportCalls()">
        <i class="fa {{bExportingCalls?'fa-spinner fa-spin':'fa-download'}} mr-2 text-secondary"></i>Bluetooth Calls
      </button>
      <button *ngIf="rootTest" class="btn btn-light ml-2"
              title="Requires enabled dialer"
              [disabled]='!dialerService.bInitialized' (click)="reportIssue()">
              Report Issue
      </button>
    </ng-container>
    </div>
    <button class="btn btn-warning" (click)="onCancel()">Close</button>
  </div>
</div>


